import MUIDataTable from 'mui-datatables';
import { useDispatch, useSelector } from 'react-redux';
import { selectAllPendingForms, setPreview, setShowHistory } from '../../giftSlice';
import { Box, Chip, IconButton, Tab, Tooltip, useMediaQuery } from '@mui/material';
import { variants } from '../../../../variants/variants';
import {
  ArrowRightAltRounded,
  CheckOutlined,
  CloseOutlined,
  ManageHistoryOutlined,
  PreviewOutlined,
  RateReviewRounded,
} from '@mui/icons-material';
import { boxBackground, colors } from '../../utility/status';
import { TabContext, TabList } from '@mui/lab';
import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { useChangeStatusMutation, useGetAllFormsQuery } from '../../giftApiSlice';
import { Typography } from '@mui/material';
import { Stack } from '@mui/material';
import UserAvatar from '../../../../common/UserAvatar';
import { format } from 'date-fns';
import toast from 'react-hot-toast';
import ViewFeedback from '../common/ViewFeedback';
import ApproveDialog from '../common/ApproveDialog';
import { toggleSwipe } from '../../../Search/searchSlice';
import CustomRow from './CustomRow';
import CustomEmptyTable from '../common/CustomEmptyTable';

const AllPendingGift = () => {
  useGetAllFormsQuery();
  const [approve] = useChangeStatusMutation();
  const dispatch = useDispatch();
  const [result, setResult] = useState('Scheduling required');
  const forms = useSelector(selectAllPendingForms);
  const [openDialog, setOpenDialog] = useState(false);
  const [openRejectDialog, setOpenRejectDialog] = useState(false);
  const [openFeedback, setOpenFeedback] = useState(false);
  const [selected, setSelected] = useState(null);
  const [interview, setInterview] = useState(null);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  let noData = Boolean(!forms[result] || forms[result]?.length === 0);

  const handleChange = (event, newValue) => {
    setResult(newValue);
    dispatch(setPreview({ reset: true }));
  };
  const handleOpenDialog = (id) => {
    setOpenDialog(true);
    setSelected(id);
  };
  const handleOpenFeedback = (interview) => {
    setOpenFeedback(true);
    setInterview(interview);
  };
  const handleCloseFeedback = () => {
    setOpenFeedback(false);
    setInterview(null);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleOpenRejectDialog = (id) => {
    setOpenRejectDialog(true);
    setSelected(id);
  };
  const handlePassClick = async (id) => {
    try {
      let body = { status: 'HR_approved' };
      const data = await approve({ id, body }).unwrap();
      toast.success('GIFT application approved');
    } catch (err) {
      console.log('error in approving', err);
      console.log('Error approving GIFT application');
    }
  };
  const handleCloseRejectDialog = () => {
    setOpenRejectDialog(false);
  };
  const handleViewForm = (form) => {
    dispatch(
      setPreview({
        response: form.response,
        currentDesignation: form.currentDesignation,
        desiredDesignation: form.desiredDesignation,
        interview: form.interview,
      })
    );
  };
  const handleApproveGift = async (id) => {
    try {
      let body = {
        status: 'Meeting_scheduled',
      };
      const data = await approve({ id, body }).unwrap();
      toast.success('GIFT application approved');
    } catch (err) {
      console.log('error in approve gift', err);
      toast.error('Could not approve GIFT');
    }
  };
  const handleRowClick = (rowData, { dataIndex }) => {
    dispatch(toggleSwipe({ value: true }));
    window['ReactNativeWebView'] &&
      window['ReactNativeWebView']?.postMessage(JSON.stringify({ type: 'swipe', value: true }));
    handleViewForm({
      response: forms[result][dataIndex].response,
      currentDesignation: forms[result][dataIndex].currentDesignation,
      desiredDesignation: forms[result][dataIndex].desiredDesignation,
      interview: { ...forms[result][dataIndex].interviewDetails, formDetails: forms[result][dataIndex] },
    });
  };

  const columns = [
    { name: '_id', options: { display: false } },
    {
      name: 'employeeDetails',
      label: isMobile ? 'Application' : 'Employee',
      options: {
        sort: false,
        customBodyRender: (val, tableMeta) => {
          const currentDesignation = tableMeta.rowData[2].split(' - ')[0];
          const desiredDesignation = tableMeta.rowData[3].split(' - ')[0];
          const row = tableMeta.rowData;
          return isMobile ? (
            <CustomRow
              gift={row}
              result={result}
              handleOpenFeedback={handleOpenFeedback}
              handleOpenDialog={handleOpenDialog}
              handleOpenRejectDialog={handleOpenRejectDialog}
              handlePassClick={handlePassClick}
              handleApproveGift={handleApproveGift}
            />
          ) : (
            <Box>
              <Typography sx={{ fontSize: variants.BODY }}>{val?.empName}</Typography>
              <Stack direction={'row'} alignItems={'center'}>
                <Typography sx={{ fontSize: variants.TINY }}>{currentDesignation}</Typography>
                <ArrowRightAltRounded />
                <Typography sx={{ fontSize: variants.TINY }}>{desiredDesignation}</Typography>
              </Stack>
            </Box>
          );
        },
      },
    },
    {
      name: 'currentDesignation',
      label: 'From',
      options: {
        display: false,
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return value.split(' - ')[0];
        },
      },
    },
    {
      name: 'desiredDesignation',
      label: 'To',
      options: {
        display: false,
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return value.split(' - ')[0];
        },
      },
    },
    {
      name: 'submissionDate',
      label: 'Submission',
      options: {
        filter: false,
        sort: false,
        display: isMobile ? false : true,
        customBodyRender: (value) => {
          return new Date(value).toLocaleDateString();
        },
      },
    },
    {
      name: 'interviewDetails',
      label: 'Jury details',
      options: {
        display: isMobile ? false : true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          let value = forms[result][dataIndex]?.interviewDetails;
          let juryDetails = value?.juryDetails;
          let jury = value?.jury;
          let formDetails = forms[result][dataIndex];
          if (!juryDetails || juryDetails?.length === 0)
            return <Chip variant='outlined' label={'Jury not selected'} color='error' />;
          return juryDetails?.map((member, index) => {
            const interview = { formDetails, feedback: jury[index]?.feedbackForm, member };
            return (
              <Stack direction={'row'} key={index} alignItems={'center'} sx={{ mb: 1 }}>
                <UserAvatar src={member.employeePhotoPath} sx={{ width: 30, height: 30 }} />
                <Typography sx={{ fontSize: variants.TINY, ml: 1 }}>{member.empName}</Typography>
                {jury[index]?.feedbackForm && (
                  <Tooltip title='view feedback'>
                    <IconButton onClick={() => handleOpenFeedback(interview)}>
                      <RateReviewRounded fontSize='small' />
                    </IconButton>
                  </Tooltip>
                )}
              </Stack>
            );
          });
        },
      },
    },
    {
      name: 'interviewDetails',
      label: 'Interview date',
      options: {
        sort: false,
        display: isMobile ? false : true,

        customBodyRender: (value) => {
          let meetingDate = value?.juryMeetingDate || false;
          return meetingDate ? (
            <Typography sx={{ fontSize: variants.BODY }}>{format(new Date(meetingDate), 'PPpp')}</Typography>
          ) : (
            <Chip variant='outlined' label={'Meeting not scheduled'} color='error' />
          );
        },
      },
    },

    {
      name: 'result',
      label: 'Actions',
      options: {
        sort: false,
        display: isMobile ? false : result === 'Scheduling required',
        customBodyRender: (_, tableMeta) => {
          const id = tableMeta.rowData[0];
          let meetingDate = tableMeta.rowData[5]?.juryMeetingDate || false;
          return (
            <>
              <Tooltip title={'Schedule meeting'}>
                <IconButton
                  variant='outlined'
                  sx={{ borderColor: colors.Pending, color: colors.Pending }}
                  onClick={() => handleOpenDialog(id)}
                >
                  <ManageHistoryOutlined sx={{ color: colors.Pending }} />
                </IconButton>
              </Tooltip>
              {meetingDate && (
                <Tooltip title={'Approve'}>
                  <IconButton
                    variant='outlined'
                    sx={{ borderColor: colors.Pass, color: colors.Pass, ml: 1 }}
                    onClick={() => handleApproveGift(id)}
                  >
                    <CheckOutlined sx={{ color: colors.Pass }} />
                  </IconButton>
                </Tooltip>
              )}
            </>
          );
        },
      },
    },
    {
      name: 'result',
      label: 'Actions',
      options: {
        display: isMobile ? false : result === 'Scheduling completed',

        sort: false,
        customBodyRender: (_, tableMeta) => {
          const id = tableMeta.rowData[0];
          return (
            <Stack direction={'row'} alignItems={'center'}>
              <Tooltip title={'Approve'}>
                <IconButton sx={{ borderColor: colors.Pass, color: colors.Pass }} onClick={() => handlePassClick(id)}>
                  <CheckOutlined sx={{ color: colors.Pass }} />
                </IconButton>
              </Tooltip>
              <Tooltip title={'Reject'}>
                <IconButton
                  sx={{ borderColor: colors.Fail, color: colors.Fail }}
                  onClick={() => handleOpenRejectDialog(id)}
                >
                  <CloseOutlined sx={{ color: colors.Fail }} />
                </IconButton>
              </Tooltip>
            </Stack>
          );
        },
      },
    },
    {
      name: 'response',
      label: 'Form',
      options: {
        filter: false,
        sort: false,
        display: isMobile ? false : true,

        customBodyRenderLite: (dataIndex) => {
          const form = forms[result][dataIndex];
          return (
            <IconButton
              size='small'
              onClick={() =>
                handleViewForm({
                  response: form.response,
                  currentDesignation: form.currentDesignation,
                  desiredDesignation: form.desiredDesignation,
                  interview: { ...form.interviewDetails, formDetails: form },
                })
              }
            >
              <PreviewOutlined />
            </IconButton>
          );
        },
      },
    },
  ];
  return (
    <Grid
      item
      xs={12}
      md={8}
      sx={{
        p: isMobile ? 0 : 1,
        height: '100%',
        background: isMobile ? '' : variants.boxBackground.PROFILE_CARD,
        borderRadius: variants.boxRadius.MAIN,
        '& .MuiTableCell-footer': {
          p: 0,
          border: 0,
        },
      }}
    >
      <Box
        sx={{
          height: '100%',
          border: 1,
          borderRadius: variants.boxRadius.MAIN,
          background: '#fff',
          borderColor: 'divider',
          overflow: 'hidden',
        }}
      >
        <TabContext value={result}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: isMobile ? 0 : 2 }}>
            <TabList onChange={handleChange} variant='scrollable'>
              {Object.keys(forms)?.map((res, index) => {
                return (
                  <Tab
                    sx={{ fontSize: variants.TINY, color: colors[res] }}
                    key={index}
                    label={
                      <Stack direction={isMobile ? 'column' : 'row'} alignItems={'center'}>
                        <span style={{ display: 'inline-block' }}>{res}</span>
                        <span
                          style={{
                            marginLeft: '0.5rem',
                            paddingBlock: '0.15rem',
                            paddingInline: '0.75rem',
                            background: boxBackground[res],
                            borderRadius: 5,
                            color: colors[res],
                          }}
                        >
                          {(forms && forms[res]?.length) || 0}
                        </span>
                      </Stack>
                    }
                    value={res}
                  />
                );
              })}
            </TabList>
          </Box>
        </TabContext>
        <MUIDataTable
          title={null}
          data={forms[result]}
          columns={columns}
          options={{
            responsive: 'vertical',
            elevation: 0,
            selectableRows: false,
            rowsPerPage: 5,
            rowsPerPageOptions: [5, 10, 20],
            tableBodyHeight: `calc(100vh - ${isMobile ? '200px' : '220px'})`,
            viewColumns: false,
            search: false,
            searchAlwaysOpen: true,
            download: false,
            filter: false,
            print: false,
            responsive: 'standard',
            onRowClick: isMobile ? handleRowClick : () => {},
          }}
          components={{
            ...(noData && {
              TableBody: CustomEmptyTable,
            }),
          }}
        />
        <ApproveDialog
          status={'Manager_approved'}
          open={openDialog}
          handleClose={handleCloseDialog}
          title={'Schedule GIFT jury meeting'}
          label={'Please select the jury members & jury interview date:'}
          selectEmployees={true}
          selected={selected}
        />
        <ApproveDialog
          status={'Rejected'}
          open={openRejectDialog}
          handleClose={handleCloseRejectDialog}
          title={'Reject GIFT application'}
          label={'Please give an appropriate reason for not selecting the candidate:'}
          selected={selected}
          textarea={true}
          reject={true}
        />
        <ViewFeedback open={openFeedback} handleClose={handleCloseFeedback} interview={interview} />
      </Box>
    </Grid>
  );
};

export default AllPendingGift;
